(function () {
  'use strict';
  var dialog = document.getElementById('erl-reading-ivory');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var question = dialog.querySelector('textarea');
  var cta = dialog.querySelector('.erl-reading__cta');
  var saving = dialog.querySelector('.erl-reading__saving');
  var error = dialog.querySelector('.erl-reading__error');
  var heading = dialog.querySelector('h2');
  var key = 'erl_exit_1111_seen';
  var expiry = Date.parse(dialog.dataset.expiry);
  var shown = false, checking = false, busy = false, previousFocus, previousOverflow;
  var expiryTimer;
  var preview = new URLSearchParams(location.search).get('erl_popup_preview') === '1';
  var ctaText = cta.textContent;
  var productHandle = '11-11-wealth-multiplier-real-gold-bracelet';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function discountActive() { return Date.now() < expiry; }
  function updateOffer() { saving.hidden = !discountActive(); }
  function seen() {
    try { return Date.now() - Number(localStorage.getItem(key) || 0) < 7 * 86400000; }
    catch (_) { return shown; }
  }
  function syncQuestion() {
    var field = document.querySelector('#erl-options textarea[data-key="textarea-1"]');
    if (field && question.value.trim()) {
      field.value = question.value.trim();
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function show() {
    if (shown || (!preview && seen())) return;
    shown = true;
    if (!preview) { try { localStorage.setItem(key, String(Date.now())); } catch (_) {} }
    var field = document.querySelector('#erl-options textarea[data-key="textarea-1"]');
    if (field && field.value && !question.value) question.value = field.value;
    var image = dialog.querySelector('img');
    image.src = image.dataset.src;
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    updateOffer();
    dialog.showModal();
    heading.focus({ preventScroll: true });
    if (discountActive()) expiryTimer = setTimeout(updateOffer, expiry - Date.now() + 20);
  }
  function open() {
    if (shown || checking || document.visibilityState !== 'visible' || (!preview && seen())) return;
    if (document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) return;
    if (preview) { show(); return; }
    checking = true;
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (cart) {
        checking = false;
        if (cart.items.some(function (item) { return item.handle === productHandle; })) { shown = true; return; }
        show();
      }).catch(function () { checking = false; });
  }
  function close() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close', function () {
    syncQuestion();
    clearTimeout(expiryTimer);
    document.documentElement.style.overflow = previousOverflow || '';
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  dialog.querySelector('.erl-reading__close').addEventListener('click', close);
  dialog.addEventListener('click', function (e) {
    var box = dialog.getBoundingClientRect();
    if (e.target === dialog && (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom)) close();
  });
  question.addEventListener('input', syncQuestion);
  async function request(url, options) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 6000);
    try {
      var response = await fetch(url, Object.assign({ credentials: 'same-origin', signal: controller.signal }, options));
      if (!response.ok) throw new Error('Request failed');
      return response;
    } finally { clearTimeout(timeout); }
  }
  cta.addEventListener('click', async function () {
    if (busy) return;
    busy = true; cta.disabled = true; cta.textContent = dialog.dataset.busy; error.hidden = true;
    syncQuestion();
    try {
      var attributes = {};
      if (question.value.trim()) attributes['Free Reading Question from Sal'] = question.value.trim();
      var payload = { attributes: attributes };
      if (discountActive()) payload.discount = '11:11';
      await request(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      });
      if (discountActive()) {
        await request(root + 'discount/' + encodeURIComponent('11:11'));
      }
      close();
      var addButton = document.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');
      var options = document.getElementById('erl-options');
      var category = options && options.querySelector('select[data-key="QUESTION-1"]');
      var zodiac = options && options.querySelector('input[name="ZODIACSIGN-1"]:checked');
      var productQuestion = options && options.querySelector('textarea[data-key="textarea-1"]');
      var incomplete = options && ((!category || !category.value) || !zodiac || (productQuestion && !productQuestion.value.trim()));
      if (incomplete || !addButton || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') {
        var target = options || addButton;
        if (target) {
          target.scrollIntoView({ block: 'center', behavior: 'instant' });
          var focusTarget = category && !category.value ? category : productQuestion && !productQuestion.disabled && !productQuestion.value.trim() ? productQuestion : options && options.querySelector('input[name="ZODIACSIGN-1"]');
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        }
      } else {
        addButton.click();
      }
    } catch (_) {
      error.textContent = dialog.dataset.error; error.hidden = false;
    } finally {
      busy = false; cta.disabled = false; cta.textContent = ctaText;
    }
  });
  var armed = false;
  setTimeout(function () { armed = true; }, 3000);
  document.addEventListener('mouseout', function (e) {
    if (armed && !e.relatedTarget && e.clientY <= 0) open();
  });
  var lastY = window.scrollY;
  function onScroll() {
    if (shown) { window.removeEventListener('scroll', onScroll); return; }
    var y = window.scrollY;
    if (armed && lastY - y > 60 && lastY > 300) open();
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (preview) setTimeout(open, 500);
  else if (matchMedia('(hover: none) and (pointer: coarse)').matches || innerWidth <= 768) setTimeout(open, 20000);
})();
